<template>
  <div>
    <page-header :title="$t('system.website_settings')" />
    <page-body class="page">
      <div class="section">
        <div class="title">{{ $t('system.website.title_settings') }}</div>
        <a-input :placeholder="$t('system.website.enter_title_placeholder')" class="input" @change="handleTitleChanged" :value="currentTitle" />
        <a-button @click="handleSaveTitle">{{ $t('system.website.save_button') }}</a-button>
      </div>
      <div class="section">
        <div class="title">{{ $t('system.website.icon_settings') }}</div>
        <a-upload name="file" :customRequest="uploadFile" :showUploadList="false"> <a-button> <a-icon type="upload" />
            {{ $t('system.website.upload_icon_button') }} </a-button>
        </a-upload>
        <div><img :src="base64String" alt="" class="img" /></div>
      </div>
      <div>
        <div class="title">{{ $t('system.website.favicon_settings') }}</div>
        <a-upload name="file" :customRequest="uploadFavicon" :showUploadList="false">
          <a-button> <a-icon type="upload" /> {{ $t('system.website.upload_favicon_button') }} </a-button>
        </a-upload>
        <div><img :src="base64StringFavicon" alt="" class="img" /></div>
      </div>
    </page-body>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'WebsiteConfig',
  data () {
    return {
      base64String: '',
      base64StringFavicon: '',
      currentTitle: '',
    }
  },
  computed: {
    ...mapState('logo', {
      websiteLogo: state => state.websiteLogo,
      remoteFavicon: state => state.favicon,
      title: state => state.title,
    }),
  },
  mounted () {
    this.currentTitle = this.title
  },
  methods: {
    async uploadFile (file) {
      const str = await this.convertFileToBase64(file.file)
      this.base64String = str
      await this.$http({
        method: 'POST',
        url: '/v1/website_configs',
        data: {
          key: 'logo',
          value: str,
        },
      })
      this.$message.success(this.$t('system.website.upload_success'))
    },

    async uploadFavicon (file) {
      const str = await this.convertFileToBase64(file.file)
      this.base64StringFavicon = str
      await this.$http({
        method: 'POST',
        url: '/v1/website_configs',
        data: {
          key: 'favicon',
          value: str,
        },
      })
      this.$message.success(this.$t('system.website.upload_success'))
    },

    async handleSaveTitle () {
      console.log(this.currentTitle)
      await this.$http({
        method: 'POST',
        url: '/v1/website_configs',
        data: {
          key: 'title',
          value: this.currentTitle,
        },
      })
      this.$message.success(this.$t('system.website.upload_success'))
    },

    async handleTitleChanged (e) {
      this.currentTitle = e.target.value
    },

    async convertFileToBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
        reader.readAsDataURL(file)
      })
    },
  },
}
</script>

<style>
.img {
  max-width: 50px;
  max-height: 50px;
}

.section {
  margin-bottom: 12px
}

.title {
  margin-bottom: 4px;
}

.page {
  padding: 8px
}

.input {
  width: 500px;
  margin-right: 10px;
}
</style>
